exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".larger-font[data-v-aa28796c] {\n  font-size: 14px;\n}\n.bolder-font[data-v-aa28796c] {\n  font-weight: 600;\n}", ""]);

